module.exports = __webpack_public_path__ + "img/sxsjs1.a82f6f1b.png";